import React from "react";
import ReactApexChart from "react-apexcharts";
import { lineChartData, lineChartOptions } from "variables/charts";

// Accepte des séries/options en props (données réelles) ; repli sur la démo sinon.
class LineChart extends React.Component {
  render() {
    const { series, options } = this.props;
    return (
      <ReactApexChart
        options={options || lineChartOptions}
        series={series || lineChartData}
        type="area"
        width="100%"
        height="100%"
      />
    );
  }
}

export default LineChart;
